import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-user-guide',
  templateUrl: './user-guide.component.html',
  styleUrls: ['./user-guide.component.css']
})
export class UserGuideComponent implements OnInit {
  bucketurl = environment.bucketUrl;
  pdfLink = 'https://d1sn8rvxrcf2ob.cloudfront.net/assets/Digital+Desk_Training_User+Guide_Final.pdf';  // PDF link
  isPdfPreviewVisible = false;
  pdfUrlData:any =''
  constructor(private sanitizer: DomSanitizer) {}

  safeUrl() {
    this.pdfUrlData = this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfLink);
  }

  ngOnInit(): void {
    this.isPdfPreviewVisible = true;
    this.safeUrl();
  }
}
